/* eslint-disable no-unreachable */
import React, { useState, useEffect, useContext, useRef } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useReactToPrint } from "react-to-print";
import { Container, Row } from "react-bootstrap";
import ResponsiveDrawer from "../Drawer/drawer";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import CircularIndeterminate from "../Loader/Loader";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Notification from "../AlertNotification/Message";
import "../Orders/orderinfo.css";
import Logoutloader from "../Loader/loaderlogout";
import * as XLSX from "xlsx";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Divider } from "semantic-ui-react";
import OrderPrintTable from "./PrintingXls";
import { formatDate, sendPdfEmployee, getProductSizeRange } from "../../ReusableComponents/functions";
// import { generateOrderPDF } from "./PDFGenerator";
// import { DownloadTableExcel } from "react-export-table-to-excel";

//  {
//         headers: {
//           "x-auth-header": sessionStorage.getItem("token"),
//         },
//       }
//
const drawerWidth = 240;
//
//
const PurchaseOrder = () => {
  const tableRef = useRef(null);

  let total = "";
  let newlist = [];
  let subtotal = [];

  const navigate = useNavigate();
  //

  //////

  //
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  ///////////////////////////
  const [donex, setdonex] = useState(false);
  const [totalobj, settotalobj] = useState("");
  const [email_1, setemail_1] = useState("");
  const [comoninfo, setcomoninfo] = useState({});
  ////////////////////////////
  ////////////////////////////

  ////////////////////////////
  ///////////////////////////////shipTo

  const [Size1, setSize1] = useState("");
  const [Price1, setPrice1] = useState("");
  const [Size2, setSize2] = useState("");
  const [Price2, setPrice2] = useState("");
  const [Size3, setSize3] = useState("");
  const [Price3, setPrice3] = useState("");

  //
  // const [Date, setDate] = useState("");

  const [done, setdone] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [ProductDetails, setProductDetails] = useState([]);
  const [orderslist, setOrderslist] = useState([]);
  const [vieworders, setvieworders] = useState([]);
  const { order_number } = useParams();
  ///////

  //
  useEffect(() => {
    sessionStorage.getItem("payloadout") != "true"
      ? navigate("/")
      : setdone(true);
    // OrderInfo();
    // GetEmails();
    ShowOtherContact();
    getorderdetails();
    GetPdf();
    OrderX();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //
  /////>>>>>>>

  //
  const OrderX = () => {
    axios
      .post("/get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((res) => {
        axios
          .post(
            `get-order-details-admin`,
            {
              order_number: order_number,
            },
            {
              headers: {
                "x-auth-header": res.data.token,
              },
            }
          )
          .then((response) => {
            setvieworders(response.data.orders);
            setProductDetails(response.data.products);
            response.data.products.map((orders) => {
              setSize1(orders.Size1);
              setPrice1(orders.Price1);
              setSize2(orders.Size2);
              setPrice2(orders.Price2);
              setSize3(orders.Size3);
              setPrice3(orders.Price3);
            });
            // }))
            const skx = response.data.products.map((sk) => {
              return sk.sku;
            });
            // setskuzx(skx)
            // console.log(skx);
            newlist.push(
              skx.forEach((value) =>
                response.data.orders.filter((obj) => {
                  return obj.sku == value;
                })
              )
            );

            setOrderslist(newlist && newlist);
            // console.log(orderslist);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  };
  let dollarUSLocale = Intl.NumberFormat("en-US");
  const [customermail, setcustomermail] = useState("");
  const [customermaila, setcustomermaila] = useState("");
  const [customermailb, setcustomermailb] = useState("");
  const [customermailc, setcustomermailc] = useState("");

  const [emails, setEmails] = useState([]);
  const [pdf, setpdf] = useState([]);
  const [pdfmail, setpdfmail] = useState("");

  const GetPdf = () => {
    axios
      .post("/get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((res) => {
        axios
          .post(
            `/get-pdf`,
            {
              order_number: order_number,
            },
            {
              headers: {
                "x-auth-header": res.data.token,
              },
            }
          )
          .then((response) => {
            response.data.length > 0
              ? setpdfmail(response.data[0].file)
              : setpdfmail("#");
            setpdf(response.data);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
    // console.log(response.data);
  };
  const [displayCustomerId, setdisplayCustomerId] = useState("");
  const [showemail, setshowemail] = useState(false);

  useEffect(() => {
    if (comoninfo?.customerId) {
      axios
        .post("/get-token", {
          id: sessionStorage.getItem("token_id"),
        })
        .then((res) => {
          axios
            .post(
              `/get-customers`,
              {
                customerid: comoninfo.customerId,
              },
              {
                headers: {
                  "x-auth-header": res.data.token,
                },
              }
            )
            .then((response) => {
              if (response.data && response.data.length > 0) {
                const cust =
                  response.data.find(
                    (c) =>
                      c._id === comoninfo.customerId ||
                      c._id?.$oid === comoninfo.customerId ||
                      c.customerid === comoninfo.customerId
                  ) || response.data[0];

                if (cust) {
                  if (cust.customerid) {
                    setdisplayCustomerId(cust.customerid);
                  }
                  if (cust.email_1) setcustomermail(cust.email_1);
                  if (cust.email_2) setcustomermaila(cust.email_2);
                  if (cust.sc_email) setcustomermailb(cust.sc_email);
                  if (cust.tc_email) setcustomermailc(cust.tc_email);
                }
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    }
  }, [comoninfo?.customerId]);

  const ShowOtherContact = () => {
    setdonex(true);
    axios
      .post("/get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((res) => {
        axios
          .post(
            `/get-customers`,
            {
              customerid: comoninfo.customerId,
            },
            {
              headers: {
                "x-auth-header": res.data.token,
              },
            }
          )
          .then((response) => {
            if (response.data && response.data.length > 0) {
              const cust =
                response.data.find(
                  (c) =>
                    c._id === comoninfo.customerId ||
                    c._id?.$oid === comoninfo.customerId ||
                    c.customerid === comoninfo.customerId
                ) || response.data[0];

              if (cust && cust.customerid) {
                setdisplayCustomerId(cust.customerid);
              }
              response.data.map((mail) => {
                setcustomermail(mail.email_1);
                setcustomermaila(mail.email_2);
                setcustomermailb(mail.sc_email);
                setcustomermailc(mail.tc_email);
              });
            }

            setdonex(false);
            // console.log(response.data);
          })
          .catch((err) => {
            console.log(err);
            setdonex(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setdonex(false);
      });
    setshowemail(!showemail);
  };
  //////////////
  const [orderdetails, setorderdetails] = useState([]);
  const [orderdate, setorderdate] = useState("");
  const [pagenum, setpagenum] = useState(1);
  const [token, settoken] = useState("");
  const [totalpairs, settotalpairs] = useState("");
  const getorderdetails = () => {
    axios
      .post("/get-token", {
        id: sessionStorage.getItem("token_id"),
      })
      .then((res) => {
        settoken(res.data.token);
        // console.log(res.data.token);
        setdonex(true);
        axios
          .post(
            `/order-details-admin/${pagenum}`,
            {
              order_number: order_number,
            },
            {
              headers: {
                "x-auth-header": res.data.token,
              },
            }
          )
          .then((response) => {
            // console.log(response);
            const sum = response.data.products.reduce((accumulator, object) => {
              return accumulator + object.totalPairs;
            }, 0);
            console.log("response", response);
            // console.log(
            //   "Image data check:",
            //   response.data.products.map((p) => ({
            //     sku: p.sku,
            //     image: p.image,
            //     Picture: p.Picture,
            //   }))
            // );
            settotalpairs(sum);
            setpagenum(pagenum + 1);
            setcomoninfo(response.data.commonInfo);
            setorderdetails(response.data.products);
            settotalobj(response.data.commonInfo.totalObjs);
            setorderdate(formatDate(response.data.commonInfo.date));

            // setdonex(false);
            setdone(false);

            // console.log(response.data);
          })
          .catch((err) => {
            setdone(false);
            console.log(err.response);
          });
      })
      .catch((err) => console.log(err));
    setshowemail(!showemail);
  };
  //////////
  const fetchMoreData = () => {
    axios
      .post(
        `/order-details-admin/${pagenum}`,
        {
          order_number: order_number,
        },
        {
          headers: {
            "x-auth-header": token && token,
          },
        }
      )
      .then((response) => {
        // console.log(response);
        const sum = response.data.products.reduce((accumulator, object) => {
          return accumulator + object.totalPairs;
        }, 0);
        console.log(sum);
        settotalpairs(totalpairs + sum);
        setorderdetails((prevState) => [
          ...prevState,
          ...response.data.products,
        ]);

        setpagenum(pagenum + 1);

        setdone(false);
      })
      .catch((err) => {
        setdone(false);
        console.log(err.response);
      });
  };
  //////
  const [pdfsend, setPdfsend] = useState("");
  const [file, setfile] = useState("");
  const HandleSubmit = (e) => {
    e.preventDefault();
    SendPDF();
  };
  const effectivePdf = file || (pdf.length > 0 ? pdf[0].file : pdfmail);

  // API calling
  const SendPDF = async () => {
    setdone(true);
    try {
      await sendPdfEmployee(email_1, effectivePdf, comoninfo.storeName, order_number);
      setdone(false);
      setNotify({
        isOpen: true,
        message: "Sent Successfully",
        type: "success",
      });
    } catch (err) {
      setdone(false);
      console.error(err);
      setNotify({
        isOpen: true,
        message: "Sending Failed",
        type: "error",
      });
    }
  };

  const Showmessage = () => {
    setNotify({
      isOpen: true,
      message: `No Pdf Found!`,
      type: "error",
    });
  };

  const runCallback = (cb) => {
    return cb();
  };
  //////
  const [ef, setef] = useState(false);
  const [esec, setesec] = useState(false);
  const [ethird, setethird] = useState(false);
  const [efour, setefour] = useState(false);
  const [eadmin, seteadmin] = useState(false);
  const commafunc = (amount) => {
    const optionsa = { style: "currency", currency: "USD" };
    return amount.toLocaleString("en-US", optionsa);
  };

  // Helper function to get all unique sizes across all products
  const getAllSizes = () => {
    if (!orderdetails || orderdetails.length === 0) return [];
    const allSizes = new Set();
    orderdetails.forEach((detail) => {
      if (detail.sizes && detail.sizes.length > 0) {
        detail.sizes.forEach((size) => {
          allSizes.add(parseInt(size.size));
        });
      }
    });
    return Array.from(allSizes).sort((a, b) => a - b);
  };

  // Helper function to get quantity for a specific size
  const getQuantityForSize = (detail, targetSize) => {
    if (!detail.sizes || detail.sizes.length === 0) return 0;
    const sizeData = detail.sizes.find((s) => parseInt(s.size) === targetSize);
    return sizeData ? sizeData.pairs : 0;
  };

  return (
    <div className="overflow-hidden">
      <ResponsiveDrawer heading="Kinderland Purchase Order" />
      <Box
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
        component="main"
      >
        <Toolbar />
        <div className="me-3 d-flex justify-content-end p-4">
          <div className="d-flex align-items-center gap-2">
            {orderdetails.length == totalobj && (
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="CSV small d-inline-flex align-items-center justify-content-center download-table-xls-button"
                table="csv-export-table"
                filename={`${comoninfo.storeName}_#${order_number}`}
                sheet={`Order-#${order_number}`}
                buttonText="Export CSV"
              />
            )}
            {pdf.length > 0 ? (
              <a
                href={pdf[0].file}
                download={`${(comoninfo?.storeName || '').trim() || 'Store'}_${order_number}.pdf`}
                className="d-inline-flex text-decoration-none"
              >
                <button className="CSV small d-inline-flex align-items-center justify-content-center">
                  Download PDF
                </button>
              </a>
            ) : (
              <button
                className="CSVd small d-inline-flex align-items-center justify-content-center"
                onClick={Showmessage}
              >
                Download PDF
              </button>
            )}

            <button
              className="CSV small d-inline-flex align-items-center justify-content-center px-4"
              onClick={() => {
                navigate("/OrderHistory");
              }}
            >
              Home
            </button>
          </div>

          {/* <DownloadTableExcel
            filename="users table"
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button> Export excel </button>
          </DownloadTableExcel> */}
        </div>
        {done ? (
          <CircularIndeterminate className="AddAgentloader" />
        ) : (
          <div>
            <table id="table-to-xlsx">
              {/* <table ref={tableRef}> */}
              <Container
                className="mt-3 w-auto overflow-auto"
                ref={componentRef}
              >
                <Row className="mx-4">
                  <div className="  top__section py-4">
                    <div className="d-flex flex-row">
                      <table>
                        <tr>
                          <td>
                            <div>
                              <div className="d-flex flex-column">
                                <small>
                                  <span className="ms-2 me-4 fw-bolder">
                                    STORE&nbsp;NAME:{" "}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex flex-column">
                                <small>
                                  <span className="ms-2 me-4 fw-bolder">
                                    PO#:{" "}
                                  </span>
                                </small>
                              </div>
                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    CUSTOMER ID:{" "}
                                  </span>
                                  {/* {console.log()} */}
                                  {/* <small className=" ms-5">&nbsp;{customerId}</small> */}
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    BUYER NAME:{" "}
                                  </span>
                                  {/* {console.log()} */}
                                  {/* <small className=" ms-5">&nbsp;{customerName}</small> */}
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    CUSTOMER EMAIL:{" "}
                                  </span>
                                  {/* {console.log()} */}
                                  {/* <small className=" ms-4">&nbsp;{customeremail}</small> */}
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    CUSTOMER&nbsp;PHONE:{" "}
                                  </span>
                                  {/* {console.log()} */}
                                  {/* <small className=" ms-3">&nbsp;{phone}</small> */}
                                </small>
                              </div>

                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    ORDER&nbsp;DATE:{" "}
                                  </span>
                                  {/* <small className="ms-5">&nbsp;&nbsp; {orderdate}</small> */}
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    START&nbsp;DATE:{" "}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    CANCEL&nbsp;DATE:
                                  </span>
                                  {/* <small className="ms-5 ">&nbsp;{cancelDate}</small> */}
                                </small>
                              </div>

                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    PAYMENT&nbsp;TERM:
                                  </span>
                                </small>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div>
                              <div className="d-flex flex-column">
                                <small>
                                  <span className="ms-2 me-4 fw-bolder">
                                    {comoninfo.storeName}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex flex-column">
                                <small>
                                  <span className="ms-2 me-4 fw-bolder">
                                    {comoninfo.order_number}
                                  </span>
                                </small>
                              </div>

                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {displayCustomerId || comoninfo.customerId}{" "}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {comoninfo.customerName}{" "}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {comoninfo.customerEmail1}{" "}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {comoninfo.phoneNumber}{" "}
                                  </span>
                                </small>
                              </div>

                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {formatDate(orderdate)}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {formatDate(comoninfo?.startDate)}
                                  </span>
                                </small>
                              </div>
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {formatDate(comoninfo?.cancelDate)}
                                  </span>
                                </small>
                              </div>

                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2 me-4 mt-4">
                                    {comoninfo.paymentTerm}
                                  </span>
                                </small>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    {/*  */}
                    {/*  */}
                    <table>
                      <tr>
                        <div className="d-flex flex-column">
                          <div className=" me-5 d-flex flex-column">
                            <td>
                              <div className=" text-dark d-flex mt-2">
                                <h6>
                                  <span className="fw-bolder">
                                    &ensp;Shipping&nbsp;Address:{" "}
                                  </span>
                                </h6>
                              </div>
                            </td>
                            {/*  */}
                            {/*  */}
                            <td>
                              <div className="d-flex">
                                <small>
                                  <span className="">
                                    &nbsp;&nbsp;&nbsp;{comoninfo.storeName}
                                  </span>
                                </small>
                              </div>
                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2">
                                    &nbsp;{comoninfo.shipTo}
                                  </span>
                                </small>
                              </div>
                              {/*  */}
                              {/*  */}
                              <div className="d-flex">
                                <small>
                                  <span className="ms-2">
                                    &nbsp;{comoninfo.shipToCity}&nbsp;
                                    {comoninfo.shipToState},&nbsp;
                                    {comoninfo.shipToPostcode}
                                  </span>
                                </small>
                              </div>
                            </td>
                          </div>

                          {/* /////BILLING Adress */}
                          <table>
                            <tr>
                              <div className="me-5 d-flex flex-column ">
                                <td>
                                  <div className=" text-dark d-flex mt-2">
                                    <h6>
                                      <span className="fw-bolder">
                                        &ensp;Billing&nbsp;Address:{" "}
                                      </span>
                                    </h6>
                                  </div>
                                </td>
                                {/*  */}
                                {/*  */}
                                <td>
                                  <div className="d-flex">
                                    <small>
                                      {/* <span className="ms-2 me-4">Ship&nbsp;To: </span> */}
                                      <span className="">
                                        &nbsp;&nbsp;&nbsp;
                                        {comoninfo.billingShipToStreet}
                                      </span>
                                    </small>
                                  </div>
                                  {/*  */}
                                  {/*  */}
                                  <div className="d-flex">
                                    <small>
                                      <span className="ms-2">
                                        &nbsp;{comoninfo.billingShipToCity}
                                        &nbsp;
                                        {comoninfo.billingShipToState},&nbsp;
                                        {comoninfo.billingShipToPostcode}
                                      </span>
                                    </small>
                                  </div>
                                </td>
                              </div>
                            </tr>
                          </table>
                        </div>
                      </tr>
                    </table>
                  </div>
                </Row>
                <hr className="fw-bolder mx-4" />
                <InfiniteScroll
                  dataLength={orderdetails.length}
                  next={fetchMoreData}
                  hasMore={orderdetails.length !== totalobj}
                  loader={<h4>Loading...</h4>}
                >
                  <Row className="mx-0">
                    {orderdetails.map((detail, index, i) => (
                      <>
                        <div className="px-4 mt-4" key={index}>
                          <div className="py-2 for_top-Content w-100 px-3">
                            <small className="text-dark">
                              <b>
                                {detail.styleFactory}&nbsp;&nbsp;{detail.sku}
                              </b>
                              <br />
                              {detail.Material1 == "" ||
                                detail.Material1 == null
                                ? ""
                                : detail.Material1}
                              {detail.Material2 == "" ||
                                detail.Material2 == null
                                ? ""
                                : "/" + detail.Material2}
                              {detail.Material3 == "" ||
                                detail.Material3 == null
                                ? ""
                                : "/" + detail.Material3}
                            </small>
                          </div>
                          <table className="forTableCollapse w-auto overflow-auto">
                            <tbody>
                              <tr
                                id="tableRow"
                                className=" w-auto overflow-auto"
                              >
                                <td rowSpan="2" id="tabledata" className="">
                                  {" "}
                                  <img
                                    src={detail.image || detail.Picture || ""}
                                    alt=""
                                    className=" orderimage"
                                    width={40}
                                    height={30}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                    }}
                                  />
                                </td>
                                {getProductSizeRange(detail).map((size) => (
                                  <td
                                    key={size}
                                    id="tabledata"
                                    className="ps-2 text-center"
                                  >
                                    <small className="fw-bolder pe-1">
                                      {size}
                                    </small>
                                  </td>
                                ))}
                              </tr>
                              <tr id="tableRow">
                                {getProductSizeRange(detail).map((size) => {
                                  const qty = getQuantityForSize(detail, size);
                                  return (
                                    <td
                                      key={size}
                                      id="tabledata"
                                      className="px-2 text-center"
                                    >
                                      <small>
                                        {qty > 0 ? qty : ""}
                                      </small>
                                    </td>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </table>
                          <div className="for_botton-Content d-flex justify-content-between ps-3">
                            <div>
                              <small className="text-dark mt-3">
                                <span>
                                  {detail.Size1 == "" || detail.Size1 == null
                                    ? ""
                                    : `${detail.Size1} =`}
                                </span>
                                <span className="">
                                  {detail.Price1 == "" || detail.Price1 == null
                                    ? ""
                                    : `$${detail.Price1}`}
                                </span>
                              </small>
                            </div>
                            <div>
                              <small className="text-dark mt-3">
                                <span>
                                  {detail.Size2 == "" || detail.Size2 == null
                                    ? ""
                                    : `${detail.Size2} =`}
                                </span>
                                <span className="">
                                  {detail.Price2 == "" || detail.Price2 == null
                                    ? ""
                                    : `$${detail.Price2}`}
                                </span>
                              </small>
                            </div>
                            <div>
                              <small className="text-dark mt-3">
                                <span>
                                  {detail.Size3 == "" || detail.Size3 == null
                                    ? ""
                                    : `${detail.Size3} =`}
                                </span>
                                <span className="">
                                  {detail.Price3 == "" || detail.Price3 == null
                                    ? ""
                                    : `$${detail.Price3}`}
                                </span>
                              </small>
                            </div>
                            <div className="d-flex flex-column justify-content-end forQTP my-1 px-4">
                              <div className="d-flex justify-content-end">
                                <small className=" text-dark fw-bold">
                                  {detail.totalPairs}
                                  &nbsp;Pairs
                                </small>
                              </div>
                              <div>
                                <small className="text-dark fw-bolder">
                                  <span className="">Total= </span>
                                  <span className="">
                                    ${commafunc(detail.totalSales)}
                                  </span>
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <table>
                          <tr>
                            <td></td>
                          </tr>
                        </table>
                      </>
                    ))}
                  </Row>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                </InfiniteScroll>
                {/* /////////////////////// HELLO */}

                {/*  */}
                {/* );
              })} */}
                {/* NEXT-CONTENT */}
                <div className="d-flex justify-content-between mx-4 my-5">
                  <div className="signandImg">
                    <div className="forSignature fw-bolder my-3">
                      <img
                        src={comoninfo.SignImg}
                        alt="SignImg.png"
                        className="SignImage"
                        width={40}
                        height={30}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    </div>
                    <div className="fw-bolder text-danger">
                      <FormGroup className="d-flex">
                        <FormControlLabel
                          control={<Checkbox />}
                          label="Email To Customer"
                          onChange={() => ShowOtherContact()}
                        />
                      </FormGroup>
                    </div>
                    <div className={showemail ? "showpartnercontact" : null}>
                      <div className="ShowHide">
                        <div>
                          {/* <p className="ms-1"> */}
                          <small>
                            {donex ? (
                              <Logoutloader className="lk" />
                            ) : (
                              <>
                                {customermail == null || customermail == "" ? (
                                  <>
                                    <small>NO Email Found!</small>
                                    <br />{" "}
                                  </>
                                ) : ef ? (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermail && customermail}
                                      value={customermail && customermail}
                                      defaultChecked
                                      disabled
                                    />
                                  </FormGroup>
                                ) : (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermail && customermail}
                                      value={customermail && customermail}
                                      onChange={async () => {
                                        setdonex(true);
                                        try {
                                          await sendPdfEmployee(customermail, effectivePdf, comoninfo.storeName, order_number);
                                          setdonex(false);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sent Successfully",
                                            type: "success",
                                          });
                                          setef(true);
                                        } catch (err) {
                                          setdonex(false);
                                          console.error(err);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sending Failed",
                                            type: "error",
                                          });
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                )}
                                {customermaila == null ||
                                  customermaila == "" ? (
                                  <>
                                    <small>NO Email Found!</small>
                                    <br />{" "}
                                  </>
                                ) : esec ? (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermaila && customermaila}
                                      value={customermaila && customermaila}
                                      disabled
                                      defaultChecked
                                    />
                                  </FormGroup>
                                ) : (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermaila && customermaila}
                                      value={customermaila && customermaila}
                                      onChange={async () => {
                                        setdonex(true);
                                        try {
                                          await sendPdfEmployee(customermaila, effectivePdf, comoninfo.storeName, order_number);
                                          setdonex(false);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sent Successfully",
                                            type: "success",
                                          });
                                          setesec(true);
                                        } catch (err) {
                                          setdonex(false);
                                          console.error(err);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sending Failed",
                                            type: "error",
                                          });
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                )}

                                {customermailb == null ||
                                  customermailb == "" ? (
                                  <>
                                    <small>NO Email Found!</small>
                                    <br />{" "}
                                  </>
                                ) : ethird ? (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermailb && customermailb}
                                      value={customermailb && customermailb}
                                      disabled
                                    />
                                  </FormGroup>
                                ) : (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermailb && customermailb}
                                      value={customermailb && customermailb}
                                      onChange={async () => {
                                        setdonex(true);
                                        try {
                                          await sendPdfEmployee(customermailb, effectivePdf, comoninfo.storeName, order_number);
                                          setdonex(false);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sent Successfully",
                                            type: "success",
                                          });
                                          setethird(true);
                                        } catch (err) {
                                          setdonex(false);
                                          console.error(err);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sending Failed",
                                            type: "error",
                                          });
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                )}

                                {customermailc == null ||
                                  customermailc == "" ? (
                                  <>
                                    <small>NO Email Found!</small>
                                    <br />{" "}
                                  </>
                                ) : efour ? (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      disabled
                                      label={customermailc && customermailc}
                                      value={customermailc && customermailc}
                                    // onClick={Showmessage}
                                    />
                                  </FormGroup>
                                ) : (
                                  <FormGroup className="d-flex">
                                    <FormControlLabel
                                      control={<Checkbox />}
                                      label={customermailc && customermailc}
                                      value={customermailc && customermailc}
                                      onChange={async () => {
                                        setdonex(true);
                                        try {
                                          await sendPdfEmployee(customermailc, effectivePdf, comoninfo.storeName, order_number);
                                          setdonex(false);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sent Successfully",
                                            type: "success",
                                          });
                                          setefour(true);
                                        } catch (err) {
                                          setdonex(false);
                                          console.error(err);
                                          setNotify({
                                            isOpen: true,
                                            message: "Sending Failed",
                                            type: "error",
                                          });
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                )}
                              </>
                            )}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="fw-bolder text-primary">
                      {eadmin ? (
                        <FormGroup className="d-flex">
                          <FormControlLabel
                            disabled
                            control={<Checkbox />}
                            label="Email To Admin"
                            // onChange={() => ShowOtherContact()}
                            onClick={Showmessage}
                          />
                        </FormGroup>
                      ) : (
                        <FormGroup className="d-flex">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Email To Office"
                            // onChange={() => ShowOtherContact()}
                            onChange={async () => {
                              setdonex(true);
                              try {
                                await sendPdfEmployee("Danny@venettini.com", effectivePdf, comoninfo.storeName, order_number);
                                setdonex(false);
                                setNotify({
                                  isOpen: true,
                                  message: "Sent Successfully",
                                  type: "success",
                                });
                                seteadmin(true);
                              } catch (err) {
                                setdonex(false);
                                console.error(err);
                                setNotify({
                                  isOpen: true,
                                  message: "Sending Failed",
                                  type: "error",
                                });
                              }
                            }}
                          />
                        </FormGroup>
                      )}
                      <div className="mt-3">
                        {/* {orderdetails.length == totalobj && (
                          <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="ms-2 py-2 px-2 ExcelDownlad download-table-xls-button"
                            table="csv-export-table"
                            filename={`${comoninfo.storeName}_#${order_number}`}
                            sheet={`Order-#${order_number}`}
                            buttonText="Export&nbsp;CSV"
                            size="small"
                          />
                        )} */}
                      </div>
                    </div>

                    {/* {pdf.map((pd) => (
                    <p>{pd.file}</p>
                  ))} */}
                  </div>
                  <div className="shippingTable">
                    <div className="next__content mt-5">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <small className=" me-5">Total&nbsp;Pairs:</small>
                            </td>
                            <td>
                              {" "}
                              <small>
                                {/* <b> ${comoninfo.grandTotal}</b> */}
                                <b> {totalpairs && totalpairs}</b>
                              </small>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <small className="">Total</small>
                            </td>
                            <td>
                              <b>
                                {" "}
                                <small className="mt-2">
                                  ${dollarUSLocale.format(comoninfo.grandTotal)}
                                </small>
                              </b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Container>

              {/* ////// */}
            </table>
          </div>
        )}

        {/* Hidden table for CSV export - matches the format in the image */}
        <div
          style={{
            display: "none",
          }}
        >
          <table
            id="csv-export-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "12px",
              border: "2px solid #000",
            }}
          >
            <OrderPrintTable
              comoninfo={{
                ...comoninfo,
                customerId: displayCustomerId || comoninfo.customerId,
              }}
              orderdetails={orderdetails}
              orderdate={orderdate}
              totalpairs={totalpairs}
              dollarUSLocale={dollarUSLocale}
              getAllSizes={getAllSizes}
              getQuantityForSize={getQuantityForSize}
            />
          </table>
        </div>
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};
export default PurchaseOrder;
